/**
 * OpenID Connect configuration for authentication
 */

// This configuration uses the ServiceWorker mode only
// "access_token" will be provided automatically to the urls and domains configured inside "OidcTrustedDomains.js"
export const oidcConfiguration = {
  clientId: "microcumulus-dash",
  redirectUri: window.location.toString(),
  scope: "openid profile email offline_access",
  authority: "https://auth.ucml.dev/realms/microcumulus",
  autoSignIn: false,
  automaticSilentRenew: true,
  postLogoutRedirectUri: window.location.origin,
  monitorSession: true,
  userStore: localStorage,
  storage: localStorage,
  storeAuthStateInCookie: false,
  silentRequestTimeoutInSeconds: 30,
  checkSessionIntervalInSeconds: 10,
  // 'https://microcumul.us',
  // service_worker_relative_url:'/OidcServiceWorker.js',
  // service_worker_only:true,
};

export default oidcConfiguration;
